import React from "react";
import { containerClassName } from "@/lib/container";

const STATS = [
  { id: "stat-uptime", k: "99.99%", v: "Uptime SLA" },
  { id: "stat-response", k: "15 min", v: "Response time" },
  { id: "stat-clients", k: "200+", v: "Enterprise clients" },
  { id: "stat-coverage", k: "24/7/365", v: "Always on" },
];

const StatsGrid = ({ className = "" }) => (
  <div
    className={`grid grid-cols-2 gap-px bg-white/10 border border-white/10 rounded-2xl overflow-hidden ${className}`}
  >
    {STATS.map((s) => (
      <div
        key={s.id}
        data-testid={s.id}
        className="bg-zinc-950 px-5 py-6 xl:px-6 xl:py-8"
      >
        <div
          className="text-2xl sm:text-3xl xl:text-4xl font-black tracking-tight text-white"
          style={{ fontFamily: "Outfit, sans-serif" }}
        >
          {s.k}
        </div>
        <div className="text-xs uppercase tracking-[0.18em] text-zinc-500 mt-1.5">
          {s.v}
        </div>
      </div>
    ))}
  </div>
);

export const Hero = () => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative w-full overflow-hidden bg-gradient-to-br from-zinc-900 via-zinc-950 to-black text-white"
    >
      {/* Decorative grid + glow */}
      <div
        aria-hidden="true"
        className="absolute inset-0 opacity-[0.08] pointer-events-none"
        style={{
          backgroundImage:
            "linear-gradient(to right, rgba(255,255,255,0.4) 1px, transparent 1px), linear-gradient(to bottom, rgba(255,255,255,0.4) 1px, transparent 1px)",
          backgroundSize: "64px 64px",
        }}
      />
      <div
        aria-hidden="true"
        className="absolute -top-32 -right-32 w-[520px] h-[520px] rounded-full pointer-events-none"
        style={{
          background:
            "radial-gradient(circle at center, rgba(255,69,0,0.35), rgba(255,69,0,0) 65%)",
          filter: "blur(20px)",
        }}
      />

      <div
        className={`relative ${containerClassName} pt-32 pb-20 sm:pt-36 sm:pb-24 lg:pt-44 lg:pb-32 xl:pt-48 xl:pb-36`}
      >
        <div className="xl:grid xl:grid-cols-[1.15fr_0.85fr] xl:gap-12 2xl:gap-20 xl:items-center">
          <div>
            <div className="reveal-left inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-white/15 bg-white/5 text-xs uppercase tracking-[0.18em] text-zinc-300">
              <span className="w-1.5 h-1.5 rounded-full bg-[#FF4500] animate-pulse" />
              Enterprise IT, made certain
            </div>

            <h1
              data-testid="hero-headline"
              className="reveal-left mt-7 text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-[4.25rem] 2xl:text-7xl font-black leading-[1.02] tracking-[-0.03em] max-w-4xl xl:max-w-none"
              style={{ fontFamily: "Outfit, sans-serif" }}
            >
              Infrastructure that doesn’t blink.
              <br className="hidden sm:block" />
              <span className="text-zinc-400">Operations that don’t sleep.</span>
            </h1>

            <p className="reveal-left mt-6 max-w-2xl xl:max-w-none text-base sm:text-lg xl:text-xl text-zinc-400 leading-relaxed">
              Conquest IT Services designs, runs and defends the systems that keep
              modern businesses moving — cloud, networking, DevOps and 24/7 managed
              operations under a single, accountable team.
            </p>

            <div className="reveal-up mt-10 flex flex-wrap items-center gap-4">
              <a
                href="#contact"
                data-testid="hero-primary-cta"
                className="inline-flex items-center gap-2 bg-[#FF4500] hover:bg-[#ff5a1f] text-white text-sm font-semibold px-6 py-3 rounded-full transition-colors duration-200"
              >
                Start a conversation
                <span aria-hidden="true">→</span>
              </a>
              <a
                href="#services"
                data-testid="hero-secondary-cta"
                className="inline-flex items-center gap-2 border border-white/20 hover:border-white/40 text-white text-sm font-semibold px-6 py-3 rounded-full transition-colors duration-200"
              >
                Explore services
              </a>
            </div>
          </div>

          <StatsGrid className="reveal-up hidden xl:grid mt-0" />
        </div>

        <StatsGrid className="reveal-up mt-16 sm:mt-20 xl:hidden sm:grid-cols-4" />
      </div>
    </section>
  );
};

export default Hero;
